import React from 'react';

interface TaskContextType {
  task?: Tasks.Task;
}

const TaskContext = React.createContext<TaskContextType>({});

export default TaskContext;
